/**
 * services/dashboardService.ts - Dashboard Data API Service
 */

import apiClient from './apiClient';

export interface DashboardTrend {
  value: string | null;
  isUp: boolean | null;
}

export interface TopVendor {
  name: string;
  orderCount: number;
  revenue: number;
}

export interface PopularItem {
  name: string;
  count: number;
}

export interface DashboardSummary {
  totalOrders: number;
  totalRevenue: string;
  avgWaitTime: string;
  popularItems: PopularItem[];
  topVendors: TopVendor[];
  topRestaurants?: string[];
  trends: {
    orders: DashboardTrend;
    revenue: DashboardTrend;
    waitTime: DashboardTrend;
    menuItems?: DashboardTrend;
  };
  orderBreakdown: {
    pending: number;
    confirmed: number;
    preparing: number;
    ready?: number;
    outForDelivery: number;
    delivered: number;
    cancelled?: number;
  };
  activeEvents?: number;
  totalVendors?: number;
}

class DashboardService {
  private basePath = '/dashboard';

  async getSummary(vendorId?: string, startDate?: string, endDate?: string): Promise<DashboardSummary> {
    try {
      const params = new URLSearchParams();
      if (vendorId) params.append('vendorId', vendorId);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);

      const url = params.toString()
        ? `${this.basePath}/summary?${params.toString()}`
        : `${this.basePath}/summary`;

      return await apiClient.get<DashboardSummary>(url);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      throw error;
    }
  }
}

const dashboardService = new DashboardService();
export default dashboardService;
